import React, { memo, PropsWithChildren, ReactNode } from 'react';
import { Toolbar, ToolbarProps } from '@app/common';
import { Loader, MobileMenu } from '@app/components';
import { Card } from 'components/ui/card';

interface Props extends PropsWithChildren {
  toolbarProps: ToolbarProps | null;
  leftContent: ReactNode;
  rightContent: ReactNode;
  pending: boolean;
}

function LayoutProfile(props: Props) {
  const { toolbarProps, leftContent, rightContent, pending, children } = props;

  return (
    <>
      {!!toolbarProps && <Toolbar {...toolbarProps} />}
      {pending && <Loader />}
      {!pending && (
        <div className="min-h-[calc(100vh-56px)] bg-muted pb-16 md:pb-0">
          <div className="flex">
            <div className="flex-1 p-4 md:p-6 lg:p-8">
              <div className="max-w-6xl mx-auto space-y-4 md:space-y-6">
                <Card className="p-4 sm:p-6">
                  <div className="flex flex-col lg:flex-row gap-4 sm:gap-6">
                    <div className="w-full lg:w-80 lg:flex-shrink-0">
                      {leftContent}
                    </div>
                    <div className="flex-1 min-w-0">{rightContent}</div>
                  </div>
                </Card>
                <div className="w-full">{children}</div>
              </div>
            </div>
          </div>
        </div>
      )}
      <MobileMenu />
    </>
  );
}

export default memo(LayoutProfile);
